'use client'
import React, {useState} from 'react'
import classnames from 'classnames'

import {Icon} from '../Icon/Icon'
import {Text} from '../Text'
import {TAccordionItem} from './types'

import styles from './styles.module.css'

export function AccordionItem({
  header,
  headerKind,
  headerTag = 'h3',
  headerClassName,
  description,
  className,
  hasCardBackground = false,
  fontColor = 'blackTotal',
  children,
  icon,
  badge,
  caption,
  captionCN,
  descriptionCN,
}: TAccordionItem) {
  const [active, setActive] = useState(false)

  return (
    <div className={classnames(styles.root, styles[fontColor], {[styles.card]: hasCardBackground}, className)}>
      <div className={classnames(styles.headerContainer, headerClassName)} onClick={() => setActive(!active)}>
        {icon && <Icon name={icon} size="m" className={styles.linkListIcon} />}
        <div className={classnames(styles.header, styles.item)}>
          <div className={styles.linkListTitle}>
            <Text tag={headerTag} kind={headerKind || hasCardBackground ? 'body' : 'label'} color={fontColor}>
              {header}
            </Text>
            {badge && <span className={styles.linkListItemBadge}>{badge}</span>}
          </div>
          {caption && (
            <Text tag="p" kind="caption" color="textGrey" className={captionCN}>
              {caption}
            </Text>
          )}
        </div>
        <Icon
          className={classnames(styles.image, styles.item, {[styles.active]: active})}
          name="chevron"
          {...(fontColor === 'whiteTotal' && {color: 'white'})}
          {...(fontColor === 'grey90' && {color: 'var(--grey-90)'})}
        />
      </div>
      <div className={classnames(styles.description, descriptionCN, {[styles.active]: active})}>
        {description || children || ''}
      </div>
    </div>
  )
}
